import template from './booking.html';
import controller from './booking.controller';

let bookingComponent = {
    restrict: 'E',
    bindings: {
        "data": '<'
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default bookingComponent;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/booking.component.js